import { createContext } from 'react';

import type { ICurrencyConverterContext } from '../DialogCurrencyConverter.helpers';

export const CurrencyConverterContext = createContext<ICurrencyConverterContext | null>(null);
